/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddWorkPackageAssignee200,
  AddWorkPackageAssigneeRequest,
  ContractLineAllocation,
  ContractSpaceLinePlan,
  CreateContractSpaceLinePlanRequest,
  CreatePlannedItem200,
  CreatePlannedItemRequest,
  CreateSpace200,
  CreateSpaceLinePlan200,
  CreateSpaceRequest,
  CreateWorkPackage200,
  CreateWorkPackageRequest,
  DeletePlannedItem200,
  DeleteSpace200,
  DeleteSpaceLinePlan200,
  DeleteWorkPackage200,
  GetPlannedItem200,
  GetSpace200,
  GetSpaceLinePlan200,
  GetWorkPackage200,
  GetWorkPackageHistory200,
  ListCoveredSpaces200,
  PagedResponseWorkPackage,
  PlannedItem,
  RemoveWorkPackageAssignee200,
  ReplaceCoveredSpaces200,
  SavePlannedItemsRequest,
  SaveSpaceLinePlansRequest,
  SearchAllWorkPackagesParams,
  Space,
  UpdateContractSpaceLinePlanRequest,
  UpdateContractSpacesRequest,
  UpdatePlannedItem200,
  UpdatePlannedItemRequest,
  UpdateSpace200,
  UpdateSpaceLinePlan200,
  UpdateSpaceRequest,
  UpdateWorkPackage200,
  UpdateWorkPackageRequest,
  WorkPackage,
  WorkPackageAssignee
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List planned items under a work package
 */
export const listPlannedItems = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PlannedItem[]>(
      {url: `/api/v1/work-packages/${id}/planned-items`, method: 'GET', signal
    },
      );
    }
  



export const getListPlannedItemsQueryKey = (id?: string,) => {
    return [
    `/api/v1/work-packages/${id}/planned-items`
    ] as const;
    }

    
export const getListPlannedItemsQueryOptions = <TData = Awaited<ReturnType<typeof listPlannedItems>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlannedItemsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlannedItems>>> = ({ signal }) => listPlannedItems(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlannedItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlannedItems>>>
export type ListPlannedItemsQueryError = unknown


export function useListPlannedItems<TData = Awaited<ReturnType<typeof listPlannedItems>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlannedItems>>,
          TError,
          Awaited<ReturnType<typeof listPlannedItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlannedItems<TData = Awaited<ReturnType<typeof listPlannedItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlannedItems>>,
          TError,
          Awaited<ReturnType<typeof listPlannedItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlannedItems<TData = Awaited<ReturnType<typeof listPlannedItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List planned items under a work package
 */

export function useListPlannedItems<TData = Awaited<ReturnType<typeof listPlannedItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItems>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlannedItemsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Save removed, updated and added planned items in one transaction — DRAFT work package only
 */
export const savePlannedItems = (
    id: string,
    savePlannedItemsRequest: SavePlannedItemsRequest,
 ) => {
      
      
      return apiClient<PlannedItem[]>(
      {url: `/api/v1/work-packages/${id}/planned-items`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: savePlannedItemsRequest
    },
      );
    }
  


export const getSavePlannedItemsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePlannedItems>>, TError,{id: string;data: SavePlannedItemsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof savePlannedItems>>, TError,{id: string;data: SavePlannedItemsRequest}, TContext> => {

const mutationKey = ['savePlannedItems'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePlannedItems>>, {id: string;data: SavePlannedItemsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  savePlannedItems(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SavePlannedItemsMutationResult = NonNullable<Awaited<ReturnType<typeof savePlannedItems>>>
    export type SavePlannedItemsMutationBody = SavePlannedItemsRequest
    export type SavePlannedItemsMutationError = unknown

    /**
 * @summary Save removed, updated and added planned items in one transaction — DRAFT work package only
 */
export const useSavePlannedItems = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePlannedItems>>, TError,{id: string;data: SavePlannedItemsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof savePlannedItems>>,
        TError,
        {id: string;data: SavePlannedItemsRequest},
        TContext
      > => {

      const mutationOptions = getSavePlannedItemsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Add a planned item to a work package — copy-on-select from a contract line, or ad-hoc
 */
export const createPlannedItem = (
    id: string,
    createPlannedItemRequest: CreatePlannedItemRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreatePlannedItem200>(
      {url: `/api/v1/work-packages/${id}/planned-items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlannedItemRequest, signal
    },
      );
    }
  


export const getCreatePlannedItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlannedItem>>, TError,{id: string;data: CreatePlannedItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPlannedItem>>, TError,{id: string;data: CreatePlannedItemRequest}, TContext> => {

const mutationKey = ['createPlannedItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlannedItem>>, {id: string;data: CreatePlannedItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createPlannedItem(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePlannedItemMutationResult = NonNullable<Awaited<ReturnType<typeof createPlannedItem>>>
    export type CreatePlannedItemMutationBody = CreatePlannedItemRequest
    export type CreatePlannedItemMutationError = unknown

    /**
 * @summary Add a planned item to a work package — copy-on-select from a contract line, or ad-hoc
 */
export const useCreatePlannedItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlannedItem>>, TError,{id: string;data: CreatePlannedItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPlannedItem>>,
        TError,
        {id: string;data: CreatePlannedItemRequest},
        TContext
      > => {

      const mutationOptions = getCreatePlannedItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List the spaces covered by this contract (subset of its object's spaces)
 */
export const listCoveredSpaces = (
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ListCoveredSpaces200>(
      {url: `/api/v1/contracts/${contractId}/spaces`, method: 'GET', signal
    },
      );
    }
  



export const getListCoveredSpacesQueryKey = (contractId?: string,) => {
    return [
    `/api/v1/contracts/${contractId}/spaces`
    ] as const;
    }

    
export const getListCoveredSpacesQueryOptions = <TData = Awaited<ReturnType<typeof listCoveredSpaces>>, TError = unknown>(contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoveredSpacesQueryKey(contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoveredSpaces>>> = ({ signal }) => listCoveredSpaces(contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoveredSpacesQueryResult = NonNullable<Awaited<ReturnType<typeof listCoveredSpaces>>>
export type ListCoveredSpacesQueryError = unknown


export function useListCoveredSpaces<TData = Awaited<ReturnType<typeof listCoveredSpaces>>, TError = unknown>(
 contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoveredSpaces>>,
          TError,
          Awaited<ReturnType<typeof listCoveredSpaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoveredSpaces<TData = Awaited<ReturnType<typeof listCoveredSpaces>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoveredSpaces>>,
          TError,
          Awaited<ReturnType<typeof listCoveredSpaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoveredSpaces<TData = Awaited<ReturnType<typeof listCoveredSpaces>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the spaces covered by this contract (subset of its object's spaces)
 */

export function useListCoveredSpaces<TData = Awaited<ReturnType<typeof listCoveredSpaces>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoveredSpaces>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoveredSpacesQueryOptions(contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Replace the whole set of spaces covered by this contract
 */
export const replaceCoveredSpaces = (
    contractId: string,
    updateContractSpacesRequest: UpdateContractSpacesRequest,
 ) => {
      
      
      return apiClient<ReplaceCoveredSpaces200>(
      {url: `/api/v1/contracts/${contractId}/spaces`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContractSpacesRequest
    },
      );
    }
  


export const getReplaceCoveredSpacesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCoveredSpaces>>, TError,{contractId: string;data: UpdateContractSpacesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceCoveredSpaces>>, TError,{contractId: string;data: UpdateContractSpacesRequest}, TContext> => {

const mutationKey = ['replaceCoveredSpaces'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCoveredSpaces>>, {contractId: string;data: UpdateContractSpacesRequest}> = (props) => {
          const {contractId,data} = props ?? {};

          return  replaceCoveredSpaces(contractId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCoveredSpacesMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCoveredSpaces>>>
    export type ReplaceCoveredSpacesMutationBody = UpdateContractSpacesRequest
    export type ReplaceCoveredSpacesMutationError = unknown

    /**
 * @summary Replace the whole set of spaces covered by this contract
 */
export const useReplaceCoveredSpaces = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCoveredSpaces>>, TError,{contractId: string;data: UpdateContractSpacesRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCoveredSpaces>>,
        TError,
        {contractId: string;data: UpdateContractSpacesRequest},
        TContext
      > => {

      const mutationOptions = getReplaceCoveredSpacesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Save a space's own planned quantities (0 = remove) in one transaction — DRAFT/REJECTED only
 */
export const saveSpaceLinePlans = (
    contractId: string,
    spaceId: string,
    saveSpaceLinePlansRequest: SaveSpaceLinePlansRequest,
 ) => {
      
      
      return apiClient<ContractSpaceLinePlan[]>(
      {url: `/api/v1/contracts/${contractId}/spaces/${spaceId}/line-plans`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveSpaceLinePlansRequest
    },
      );
    }
  


export const getSaveSpaceLinePlansMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSpaceLinePlans>>, TError,{contractId: string;spaceId: string;data: SaveSpaceLinePlansRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveSpaceLinePlans>>, TError,{contractId: string;spaceId: string;data: SaveSpaceLinePlansRequest}, TContext> => {

const mutationKey = ['saveSpaceLinePlans'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSpaceLinePlans>>, {contractId: string;spaceId: string;data: SaveSpaceLinePlansRequest}> = (props) => {
          const {contractId,spaceId,data} = props ?? {};

          return  saveSpaceLinePlans(contractId,spaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveSpaceLinePlansMutationResult = NonNullable<Awaited<ReturnType<typeof saveSpaceLinePlans>>>
    export type SaveSpaceLinePlansMutationBody = SaveSpaceLinePlansRequest
    export type SaveSpaceLinePlansMutationError = unknown

    /**
 * @summary Save a space's own planned quantities (0 = remove) in one transaction — DRAFT/REJECTED only
 */
export const useSaveSpaceLinePlans = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSpaceLinePlans>>, TError,{contractId: string;spaceId: string;data: SaveSpaceLinePlansRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveSpaceLinePlans>>,
        TError,
        {contractId: string;spaceId: string;data: SaveSpaceLinePlansRequest},
        TContext
      > => {

      const mutationOptions = getSaveSpaceLinePlansMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List executors (teams/individuals) assigned to a work package
 */
export const listWorkPackageAssignees = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WorkPackageAssignee[]>(
      {url: `/api/v1/work-packages/${id}/assignees`, method: 'GET', signal
    },
      );
    }
  



export const getListWorkPackageAssigneesQueryKey = (id?: string,) => {
    return [
    `/api/v1/work-packages/${id}/assignees`
    ] as const;
    }

    
export const getListWorkPackageAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkPackageAssigneesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkPackageAssignees>>> = ({ signal }) => listWorkPackageAssignees(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkPackageAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkPackageAssignees>>>
export type ListWorkPackageAssigneesQueryError = unknown


export function useListWorkPackageAssignees<TData = Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkPackageAssignees>>,
          TError,
          Awaited<ReturnType<typeof listWorkPackageAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkPackageAssignees<TData = Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkPackageAssignees>>,
          TError,
          Awaited<ReturnType<typeof listWorkPackageAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkPackageAssignees<TData = Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List executors (teams/individuals) assigned to a work package
 */

export function useListWorkPackageAssignees<TData = Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackageAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkPackageAssigneesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Assign a team or an individual to a work package — exactly one of teamId/userId
 */
export const addWorkPackageAssignee = (
    id: string,
    addWorkPackageAssigneeRequest: AddWorkPackageAssigneeRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddWorkPackageAssignee200>(
      {url: `/api/v1/work-packages/${id}/assignees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addWorkPackageAssigneeRequest, signal
    },
      );
    }
  


export const getAddWorkPackageAssigneeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWorkPackageAssignee>>, TError,{id: string;data: AddWorkPackageAssigneeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addWorkPackageAssignee>>, TError,{id: string;data: AddWorkPackageAssigneeRequest}, TContext> => {

const mutationKey = ['addWorkPackageAssignee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWorkPackageAssignee>>, {id: string;data: AddWorkPackageAssigneeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addWorkPackageAssignee(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddWorkPackageAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof addWorkPackageAssignee>>>
    export type AddWorkPackageAssigneeMutationBody = AddWorkPackageAssigneeRequest
    export type AddWorkPackageAssigneeMutationError = unknown

    /**
 * @summary Assign a team or an individual to a work package — exactly one of teamId/userId
 */
export const useAddWorkPackageAssignee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWorkPackageAssignee>>, TError,{id: string;data: AddWorkPackageAssigneeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addWorkPackageAssignee>>,
        TError,
        {id: string;data: AddWorkPackageAssigneeRequest},
        TContext
      > => {

      const mutationOptions = getAddWorkPackageAssigneeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List all spaces for an object (flat — caller assembles the tree via parentSpaceId)
 */
export const listSpaces = (
    objectId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Space[]>(
      {url: `/api/v1/objects/${objectId}/spaces`, method: 'GET', signal
    },
      );
    }
  



export const getListSpacesQueryKey = (objectId?: string,) => {
    return [
    `/api/v1/objects/${objectId}/spaces`
    ] as const;
    }

    
export const getListSpacesQueryOptions = <TData = Awaited<ReturnType<typeof listSpaces>>, TError = unknown>(objectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSpacesQueryKey(objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaces>>> = ({ signal }) => listSpaces(objectId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(objectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSpacesQueryResult = NonNullable<Awaited<ReturnType<typeof listSpaces>>>
export type ListSpacesQueryError = unknown


export function useListSpaces<TData = Awaited<ReturnType<typeof listSpaces>>, TError = unknown>(
 objectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaces>>,
          TError,
          Awaited<ReturnType<typeof listSpaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSpaces<TData = Awaited<ReturnType<typeof listSpaces>>, TError = unknown>(
 objectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaces>>,
          TError,
          Awaited<ReturnType<typeof listSpaces>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSpaces<TData = Awaited<ReturnType<typeof listSpaces>>, TError = unknown>(
 objectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all spaces for an object (flat — caller assembles the tree via parentSpaceId)
 */

export function useListSpaces<TData = Awaited<ReturnType<typeof listSpaces>>, TError = unknown>(
 objectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSpacesQueryOptions(objectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a space under an object (top-level, or nested under parentSpaceId)
 */
export const createSpace = (
    objectId: string,
    createSpaceRequest: CreateSpaceRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateSpace200>(
      {url: `/api/v1/objects/${objectId}/spaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSpaceRequest, signal
    },
      );
    }
  


export const getCreateSpaceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpace>>, TError,{objectId: string;data: CreateSpaceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSpace>>, TError,{objectId: string;data: CreateSpaceRequest}, TContext> => {

const mutationKey = ['createSpace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSpace>>, {objectId: string;data: CreateSpaceRequest}> = (props) => {
          const {objectId,data} = props ?? {};

          return  createSpace(objectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSpaceMutationResult = NonNullable<Awaited<ReturnType<typeof createSpace>>>
    export type CreateSpaceMutationBody = CreateSpaceRequest
    export type CreateSpaceMutationError = unknown

    /**
 * @summary Create a space under an object (top-level, or nested under parentSpaceId)
 */
export const useCreateSpace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpace>>, TError,{objectId: string;data: CreateSpaceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSpace>>,
        TError,
        {objectId: string;data: CreateSpaceRequest},
        TContext
      > => {

      const mutationOptions = getCreateSpaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List all work packages under a single contract, across every covered space
 */
export const listWorkPackagesByContract = (
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WorkPackage[]>(
      {url: `/api/v1/contracts/${contractId}/work-packages`, method: 'GET', signal
    },
      );
    }
  



export const getListWorkPackagesByContractQueryKey = (contractId?: string,) => {
    return [
    `/api/v1/contracts/${contractId}/work-packages`
    ] as const;
    }

    
export const getListWorkPackagesByContractQueryOptions = <TData = Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError = unknown>(contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkPackagesByContractQueryKey(contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkPackagesByContract>>> = ({ signal }) => listWorkPackagesByContract(contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkPackagesByContractQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkPackagesByContract>>>
export type ListWorkPackagesByContractQueryError = unknown


export function useListWorkPackagesByContract<TData = Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError = unknown>(
 contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkPackagesByContract>>,
          TError,
          Awaited<ReturnType<typeof listWorkPackagesByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkPackagesByContract<TData = Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkPackagesByContract>>,
          TError,
          Awaited<ReturnType<typeof listWorkPackagesByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkPackagesByContract<TData = Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all work packages under a single contract, across every covered space
 */

export function useListWorkPackagesByContract<TData = Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkPackagesByContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkPackagesByContractQueryOptions(contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a work package under a contract, located at a space in the contract's object
 */
export const createWorkPackage = (
    contractId: string,
    createWorkPackageRequest: CreateWorkPackageRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateWorkPackage200>(
      {url: `/api/v1/contracts/${contractId}/work-packages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkPackageRequest, signal
    },
      );
    }
  


export const getCreateWorkPackageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkPackage>>, TError,{contractId: string;data: CreateWorkPackageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorkPackage>>, TError,{contractId: string;data: CreateWorkPackageRequest}, TContext> => {

const mutationKey = ['createWorkPackage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkPackage>>, {contractId: string;data: CreateWorkPackageRequest}> = (props) => {
          const {contractId,data} = props ?? {};

          return  createWorkPackage(contractId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkPackageMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkPackage>>>
    export type CreateWorkPackageMutationBody = CreateWorkPackageRequest
    export type CreateWorkPackageMutationError = unknown

    /**
 * @summary Create a work package under a contract, located at a space in the contract's object
 */
export const useCreateWorkPackage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkPackage>>, TError,{contractId: string;data: CreateWorkPackageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkPackage>>,
        TError,
        {contractId: string;data: CreateWorkPackageRequest},
        TContext
      > => {

      const mutationOptions = getCreateWorkPackageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List all space line plans under a single contract, across every covered space
 */
export const listSpaceLinePlansByContract = (
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ContractSpaceLinePlan[]>(
      {url: `/api/v1/contracts/${contractId}/space-line-plans`, method: 'GET', signal
    },
      );
    }
  



export const getListSpaceLinePlansByContractQueryKey = (contractId?: string,) => {
    return [
    `/api/v1/contracts/${contractId}/space-line-plans`
    ] as const;
    }

    
export const getListSpaceLinePlansByContractQueryOptions = <TData = Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError = unknown>(contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSpaceLinePlansByContractQueryKey(contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>> = ({ signal }) => listSpaceLinePlansByContract(contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSpaceLinePlansByContractQueryResult = NonNullable<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>>
export type ListSpaceLinePlansByContractQueryError = unknown


export function useListSpaceLinePlansByContract<TData = Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError = unknown>(
 contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaceLinePlansByContract>>,
          TError,
          Awaited<ReturnType<typeof listSpaceLinePlansByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSpaceLinePlansByContract<TData = Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaceLinePlansByContract>>,
          TError,
          Awaited<ReturnType<typeof listSpaceLinePlansByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSpaceLinePlansByContract<TData = Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all space line plans under a single contract, across every covered space
 */

export function useListSpaceLinePlansByContract<TData = Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSpaceLinePlansByContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSpaceLinePlansByContractQueryOptions(contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Plan a quantity of a contract line into a covered space — DRAFT/REJECTED only
 */
export const createSpaceLinePlan = (
    contractId: string,
    createContractSpaceLinePlanRequest: CreateContractSpaceLinePlanRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateSpaceLinePlan200>(
      {url: `/api/v1/contracts/${contractId}/space-line-plans`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractSpaceLinePlanRequest, signal
    },
      );
    }
  


export const getCreateSpaceLinePlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpaceLinePlan>>, TError,{contractId: string;data: CreateContractSpaceLinePlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSpaceLinePlan>>, TError,{contractId: string;data: CreateContractSpaceLinePlanRequest}, TContext> => {

const mutationKey = ['createSpaceLinePlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSpaceLinePlan>>, {contractId: string;data: CreateContractSpaceLinePlanRequest}> = (props) => {
          const {contractId,data} = props ?? {};

          return  createSpaceLinePlan(contractId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSpaceLinePlanMutationResult = NonNullable<Awaited<ReturnType<typeof createSpaceLinePlan>>>
    export type CreateSpaceLinePlanMutationBody = CreateContractSpaceLinePlanRequest
    export type CreateSpaceLinePlanMutationError = unknown

    /**
 * @summary Plan a quantity of a contract line into a covered space — DRAFT/REJECTED only
 */
export const useCreateSpaceLinePlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpaceLinePlan>>, TError,{contractId: string;data: CreateContractSpaceLinePlanRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSpaceLinePlan>>,
        TError,
        {contractId: string;data: CreateContractSpaceLinePlanRequest},
        TContext
      > => {

      const mutationOptions = getCreateSpaceLinePlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single work package
 */
export const getWorkPackage = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetWorkPackage200>(
      {url: `/api/v1/work-packages/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetWorkPackageQueryKey = (id?: string,) => {
    return [
    `/api/v1/work-packages/${id}`
    ] as const;
    }

    
export const getGetWorkPackageQueryOptions = <TData = Awaited<ReturnType<typeof getWorkPackage>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkPackageQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkPackage>>> = ({ signal }) => getWorkPackage(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkPackageQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkPackage>>>
export type GetWorkPackageQueryError = unknown


export function useGetWorkPackage<TData = Awaited<ReturnType<typeof getWorkPackage>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkPackage>>,
          TError,
          Awaited<ReturnType<typeof getWorkPackage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkPackage<TData = Awaited<ReturnType<typeof getWorkPackage>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkPackage>>,
          TError,
          Awaited<ReturnType<typeof getWorkPackage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkPackage<TData = Awaited<ReturnType<typeof getWorkPackage>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single work package
 */

export function useGetWorkPackage<TData = Awaited<ReturnType<typeof getWorkPackage>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackage>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkPackageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a work package — must have no planned items
 */
export const deleteWorkPackage = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteWorkPackage200>(
      {url: `/api/v1/work-packages/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWorkPackageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkPackage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkPackage>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteWorkPackage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkPackage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorkPackage(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkPackageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkPackage>>>
    
    export type DeleteWorkPackageMutationError = unknown

    /**
 * @summary Delete a work package — must have no planned items
 */
export const useDeleteWorkPackage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkPackage>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkPackage>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorkPackageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a work package
 */
export const updateWorkPackage = (
    id: string,
    updateWorkPackageRequest: UpdateWorkPackageRequest,
 ) => {
      
      
      return apiClient<UpdateWorkPackage200>(
      {url: `/api/v1/work-packages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkPackageRequest
    },
      );
    }
  


export const getUpdateWorkPackageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkPackage>>, TError,{id: string;data: UpdateWorkPackageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkPackage>>, TError,{id: string;data: UpdateWorkPackageRequest}, TContext> => {

const mutationKey = ['updateWorkPackage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkPackage>>, {id: string;data: UpdateWorkPackageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorkPackage(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkPackageMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkPackage>>>
    export type UpdateWorkPackageMutationBody = UpdateWorkPackageRequest
    export type UpdateWorkPackageMutationError = unknown

    /**
 * @summary Update a work package
 */
export const useUpdateWorkPackage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkPackage>>, TError,{id: string;data: UpdateWorkPackageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkPackage>>,
        TError,
        {id: string;data: UpdateWorkPackageRequest},
        TContext
      > => {

      const mutationOptions = getUpdateWorkPackageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single space
 */
export const getSpace = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetSpace200>(
      {url: `/api/v1/spaces/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetSpaceQueryKey = (id?: string,) => {
    return [
    `/api/v1/spaces/${id}`
    ] as const;
    }

    
export const getGetSpaceQueryOptions = <TData = Awaited<ReturnType<typeof getSpace>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpaceQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpace>>> = ({ signal }) => getSpace(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpaceQueryResult = NonNullable<Awaited<ReturnType<typeof getSpace>>>
export type GetSpaceQueryError = unknown


export function useGetSpace<TData = Awaited<ReturnType<typeof getSpace>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpace>>,
          TError,
          Awaited<ReturnType<typeof getSpace>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpace<TData = Awaited<ReturnType<typeof getSpace>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpace>>,
          TError,
          Awaited<ReturnType<typeof getSpace>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpace<TData = Awaited<ReturnType<typeof getSpace>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single space
 */

export function useGetSpace<TData = Awaited<ReturnType<typeof getSpace>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpaceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a space — must have no child spaces and no work packages
 */
export const deleteSpace = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteSpace200>(
      {url: `/api/v1/spaces/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSpaceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpace>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSpace>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSpace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSpace>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSpace(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSpaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSpace>>>
    
    export type DeleteSpaceMutationError = unknown

    /**
 * @summary Delete a space — must have no child spaces and no work packages
 */
export const useDeleteSpace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpace>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSpace>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSpaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a space's code/name/description/sortOrder
 */
export const updateSpace = (
    id: string,
    updateSpaceRequest: UpdateSpaceRequest,
 ) => {
      
      
      return apiClient<UpdateSpace200>(
      {url: `/api/v1/spaces/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSpaceRequest
    },
      );
    }
  


export const getUpdateSpaceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpace>>, TError,{id: string;data: UpdateSpaceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSpace>>, TError,{id: string;data: UpdateSpaceRequest}, TContext> => {

const mutationKey = ['updateSpace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSpace>>, {id: string;data: UpdateSpaceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSpace(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSpaceMutationResult = NonNullable<Awaited<ReturnType<typeof updateSpace>>>
    export type UpdateSpaceMutationBody = UpdateSpaceRequest
    export type UpdateSpaceMutationError = unknown

    /**
 * @summary Update a space's code/name/description/sortOrder
 */
export const useUpdateSpace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpace>>, TError,{id: string;data: UpdateSpaceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSpace>>,
        TError,
        {id: string;data: UpdateSpaceRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSpaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single space line plan
 */
export const getSpaceLinePlan = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetSpaceLinePlan200>(
      {url: `/api/v1/space-line-plans/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetSpaceLinePlanQueryKey = (id?: string,) => {
    return [
    `/api/v1/space-line-plans/${id}`
    ] as const;
    }

    
export const getGetSpaceLinePlanQueryOptions = <TData = Awaited<ReturnType<typeof getSpaceLinePlan>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpaceLinePlanQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpaceLinePlan>>> = ({ signal }) => getSpaceLinePlan(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpaceLinePlanQueryResult = NonNullable<Awaited<ReturnType<typeof getSpaceLinePlan>>>
export type GetSpaceLinePlanQueryError = unknown


export function useGetSpaceLinePlan<TData = Awaited<ReturnType<typeof getSpaceLinePlan>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpaceLinePlan>>,
          TError,
          Awaited<ReturnType<typeof getSpaceLinePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpaceLinePlan<TData = Awaited<ReturnType<typeof getSpaceLinePlan>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpaceLinePlan>>,
          TError,
          Awaited<ReturnType<typeof getSpaceLinePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpaceLinePlan<TData = Awaited<ReturnType<typeof getSpaceLinePlan>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single space line plan
 */

export function useGetSpaceLinePlan<TData = Awaited<ReturnType<typeof getSpaceLinePlan>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpaceLinePlan>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpaceLinePlanQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a space line plan
 */
export const deleteSpaceLinePlan = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteSpaceLinePlan200>(
      {url: `/api/v1/space-line-plans/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSpaceLinePlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpaceLinePlan>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSpaceLinePlan>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSpaceLinePlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSpaceLinePlan>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSpaceLinePlan(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSpaceLinePlanMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSpaceLinePlan>>>
    
    export type DeleteSpaceLinePlanMutationError = unknown

    /**
 * @summary Delete a space line plan
 */
export const useDeleteSpaceLinePlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpaceLinePlan>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSpaceLinePlan>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSpaceLinePlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a space line plan's plannedQty — spaceId/contractLineId are immutable
 */
export const updateSpaceLinePlan = (
    id: string,
    updateContractSpaceLinePlanRequest: UpdateContractSpaceLinePlanRequest,
 ) => {
      
      
      return apiClient<UpdateSpaceLinePlan200>(
      {url: `/api/v1/space-line-plans/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateContractSpaceLinePlanRequest
    },
      );
    }
  


export const getUpdateSpaceLinePlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpaceLinePlan>>, TError,{id: string;data: UpdateContractSpaceLinePlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSpaceLinePlan>>, TError,{id: string;data: UpdateContractSpaceLinePlanRequest}, TContext> => {

const mutationKey = ['updateSpaceLinePlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSpaceLinePlan>>, {id: string;data: UpdateContractSpaceLinePlanRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSpaceLinePlan(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSpaceLinePlanMutationResult = NonNullable<Awaited<ReturnType<typeof updateSpaceLinePlan>>>
    export type UpdateSpaceLinePlanMutationBody = UpdateContractSpaceLinePlanRequest
    export type UpdateSpaceLinePlanMutationError = unknown

    /**
 * @summary Update a space line plan's plannedQty — spaceId/contractLineId are immutable
 */
export const useUpdateSpaceLinePlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpaceLinePlan>>, TError,{id: string;data: UpdateContractSpaceLinePlanRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSpaceLinePlan>>,
        TError,
        {id: string;data: UpdateContractSpaceLinePlanRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSpaceLinePlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single planned item
 */
export const getPlannedItem = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetPlannedItem200>(
      {url: `/api/v1/planned-items/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlannedItemQueryKey = (id?: string,) => {
    return [
    `/api/v1/planned-items/${id}`
    ] as const;
    }

    
export const getGetPlannedItemQueryOptions = <TData = Awaited<ReturnType<typeof getPlannedItem>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlannedItemQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlannedItem>>> = ({ signal }) => getPlannedItem(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlannedItemQueryResult = NonNullable<Awaited<ReturnType<typeof getPlannedItem>>>
export type GetPlannedItemQueryError = unknown


export function useGetPlannedItem<TData = Awaited<ReturnType<typeof getPlannedItem>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlannedItem>>,
          TError,
          Awaited<ReturnType<typeof getPlannedItem>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlannedItem<TData = Awaited<ReturnType<typeof getPlannedItem>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlannedItem>>,
          TError,
          Awaited<ReturnType<typeof getPlannedItem>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlannedItem<TData = Awaited<ReturnType<typeof getPlannedItem>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single planned item
 */

export function useGetPlannedItem<TData = Awaited<ReturnType<typeof getPlannedItem>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlannedItem>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlannedItemQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a planned item
 */
export const deletePlannedItem = (
    id: string,
 ) => {
      
      
      return apiClient<DeletePlannedItem200>(
      {url: `/api/v1/planned-items/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePlannedItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlannedItem>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePlannedItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePlannedItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlannedItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePlannedItem(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePlannedItemMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlannedItem>>>
    
    export type DeletePlannedItemMutationError = unknown

    /**
 * @summary Delete a planned item
 */
export const useDeletePlannedItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlannedItem>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlannedItem>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePlannedItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a planned item's description/plannedQty/sortOrder — itemCode/unit are immutable
 */
export const updatePlannedItem = (
    id: string,
    updatePlannedItemRequest: UpdatePlannedItemRequest,
 ) => {
      
      
      return apiClient<UpdatePlannedItem200>(
      {url: `/api/v1/planned-items/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePlannedItemRequest
    },
      );
    }
  


export const getUpdatePlannedItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlannedItem>>, TError,{id: string;data: UpdatePlannedItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlannedItem>>, TError,{id: string;data: UpdatePlannedItemRequest}, TContext> => {

const mutationKey = ['updatePlannedItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlannedItem>>, {id: string;data: UpdatePlannedItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePlannedItem(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlannedItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlannedItem>>>
    export type UpdatePlannedItemMutationBody = UpdatePlannedItemRequest
    export type UpdatePlannedItemMutationError = unknown

    /**
 * @summary Update a planned item's description/plannedQty/sortOrder — itemCode/unit are immutable
 */
export const useUpdatePlannedItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlannedItem>>, TError,{id: string;data: UpdatePlannedItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlannedItem>>,
        TError,
        {id: string;data: UpdatePlannedItemRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePlannedItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List all work packages for the caller's organisation, across every contract
 */
export const listAllWorkPackages = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<WorkPackage[]>(
      {url: `/api/v1/work-packages`, method: 'GET', signal
    },
      );
    }
  



export const getListAllWorkPackagesQueryKey = () => {
    return [
    `/api/v1/work-packages`
    ] as const;
    }

    
export const getListAllWorkPackagesQueryOptions = <TData = Awaited<ReturnType<typeof listAllWorkPackages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllWorkPackagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllWorkPackages>>> = ({ signal }) => listAllWorkPackages(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllWorkPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAllWorkPackages>>>
export type ListAllWorkPackagesQueryError = unknown


export function useListAllWorkPackages<TData = Awaited<ReturnType<typeof listAllWorkPackages>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllWorkPackages>>,
          TError,
          Awaited<ReturnType<typeof listAllWorkPackages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllWorkPackages<TData = Awaited<ReturnType<typeof listAllWorkPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllWorkPackages>>,
          TError,
          Awaited<ReturnType<typeof listAllWorkPackages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllWorkPackages<TData = Awaited<ReturnType<typeof listAllWorkPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all work packages for the caller's organisation, across every contract
 */

export function useListAllWorkPackages<TData = Awaited<ReturnType<typeof listAllWorkPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWorkPackages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllWorkPackagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary AUD-01/AUD-02: header change history for this work package (not planned item changes)
 */
export const getWorkPackageHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetWorkPackageHistory200>(
      {url: `/api/v1/work-packages/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetWorkPackageHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/work-packages/${id}/history`
    ] as const;
    }

    
export const getGetWorkPackageHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getWorkPackageHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkPackageHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkPackageHistory>>> = ({ signal }) => getWorkPackageHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkPackageHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkPackageHistory>>>
export type GetWorkPackageHistoryQueryError = unknown


export function useGetWorkPackageHistory<TData = Awaited<ReturnType<typeof getWorkPackageHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkPackageHistory>>,
          TError,
          Awaited<ReturnType<typeof getWorkPackageHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkPackageHistory<TData = Awaited<ReturnType<typeof getWorkPackageHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkPackageHistory>>,
          TError,
          Awaited<ReturnType<typeof getWorkPackageHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkPackageHistory<TData = Awaited<ReturnType<typeof getWorkPackageHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this work package (not planned item changes)
 */

export function useGetWorkPackageHistory<TData = Awaited<ReturnType<typeof getWorkPackageHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkPackageHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkPackageHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable work package list for the main Work Packages list page
 */
export const searchAllWorkPackages = (
    params?: SearchAllWorkPackagesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseWorkPackage>(
      {url: `/api/v1/work-packages/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchAllWorkPackagesQueryKey = (params?: SearchAllWorkPackagesParams,) => {
    return [
    `/api/v1/work-packages/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchAllWorkPackagesQueryOptions = <TData = Awaited<ReturnType<typeof searchAllWorkPackages>>, TError = unknown>(params?: SearchAllWorkPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAllWorkPackagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllWorkPackages>>> = ({ signal }) => searchAllWorkPackages(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchAllWorkPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof searchAllWorkPackages>>>
export type SearchAllWorkPackagesQueryError = unknown


export function useSearchAllWorkPackages<TData = Awaited<ReturnType<typeof searchAllWorkPackages>>, TError = unknown>(
 params: undefined |  SearchAllWorkPackagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllWorkPackages>>,
          TError,
          Awaited<ReturnType<typeof searchAllWorkPackages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAllWorkPackages<TData = Awaited<ReturnType<typeof searchAllWorkPackages>>, TError = unknown>(
 params?: SearchAllWorkPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllWorkPackages>>,
          TError,
          Awaited<ReturnType<typeof searchAllWorkPackages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAllWorkPackages<TData = Awaited<ReturnType<typeof searchAllWorkPackages>>, TError = unknown>(
 params?: SearchAllWorkPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable work package list for the main Work Packages list page
 */

export function useSearchAllWorkPackages<TData = Awaited<ReturnType<typeof searchAllWorkPackages>>, TError = unknown>(
 params?: SearchAllWorkPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAllWorkPackages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAllWorkPackagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List all planned items under a single contract, across every work package/space
 */
export const listPlannedItemsByContract = (
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PlannedItem[]>(
      {url: `/api/v1/contracts/${contractId}/planned-items`, method: 'GET', signal
    },
      );
    }
  



export const getListPlannedItemsByContractQueryKey = (contractId?: string,) => {
    return [
    `/api/v1/contracts/${contractId}/planned-items`
    ] as const;
    }

    
export const getListPlannedItemsByContractQueryOptions = <TData = Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError = unknown>(contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlannedItemsByContractQueryKey(contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlannedItemsByContract>>> = ({ signal }) => listPlannedItemsByContract(contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlannedItemsByContractQueryResult = NonNullable<Awaited<ReturnType<typeof listPlannedItemsByContract>>>
export type ListPlannedItemsByContractQueryError = unknown


export function useListPlannedItemsByContract<TData = Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError = unknown>(
 contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlannedItemsByContract>>,
          TError,
          Awaited<ReturnType<typeof listPlannedItemsByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlannedItemsByContract<TData = Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlannedItemsByContract>>,
          TError,
          Awaited<ReturnType<typeof listPlannedItemsByContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlannedItemsByContract<TData = Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all planned items under a single contract, across every work package/space
 */

export function useListPlannedItemsByContract<TData = Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlannedItemsByContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlannedItemsByContractQueryOptions(contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Per-line allocated/remaining quantity and status, aggregated across all spaces of this contract
 */
export const listLineAllocations = (
    contractId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ContractLineAllocation[]>(
      {url: `/api/v1/contracts/${contractId}/lines/allocations`, method: 'GET', signal
    },
      );
    }
  



export const getListLineAllocationsQueryKey = (contractId?: string,) => {
    return [
    `/api/v1/contracts/${contractId}/lines/allocations`
    ] as const;
    }

    
export const getListLineAllocationsQueryOptions = <TData = Awaited<ReturnType<typeof listLineAllocations>>, TError = unknown>(contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLineAllocationsQueryKey(contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLineAllocations>>> = ({ signal }) => listLineAllocations(contractId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLineAllocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLineAllocations>>>
export type ListLineAllocationsQueryError = unknown


export function useListLineAllocations<TData = Awaited<ReturnType<typeof listLineAllocations>>, TError = unknown>(
 contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLineAllocations>>,
          TError,
          Awaited<ReturnType<typeof listLineAllocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLineAllocations<TData = Awaited<ReturnType<typeof listLineAllocations>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLineAllocations>>,
          TError,
          Awaited<ReturnType<typeof listLineAllocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLineAllocations<TData = Awaited<ReturnType<typeof listLineAllocations>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Per-line allocated/remaining quantity and status, aggregated across all spaces of this contract
 */

export function useListLineAllocations<TData = Awaited<ReturnType<typeof listLineAllocations>>, TError = unknown>(
 contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineAllocations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLineAllocationsQueryOptions(contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Remove an executor from a work package
 */
export const removeWorkPackageAssignee = (
    id: string,
    assigneeId: string,
 ) => {
      
      
      return apiClient<RemoveWorkPackageAssignee200>(
      {url: `/api/v1/work-packages/${id}/assignees/${assigneeId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveWorkPackageAssigneeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWorkPackageAssignee>>, TError,{id: string;assigneeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeWorkPackageAssignee>>, TError,{id: string;assigneeId: string}, TContext> => {

const mutationKey = ['removeWorkPackageAssignee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeWorkPackageAssignee>>, {id: string;assigneeId: string}> = (props) => {
          const {id,assigneeId} = props ?? {};

          return  removeWorkPackageAssignee(id,assigneeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveWorkPackageAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof removeWorkPackageAssignee>>>
    
    export type RemoveWorkPackageAssigneeMutationError = unknown

    /**
 * @summary Remove an executor from a work package
 */
export const useRemoveWorkPackageAssignee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWorkPackageAssignee>>, TError,{id: string;assigneeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeWorkPackageAssignee>>,
        TError,
        {id: string;assigneeId: string},
        TContext
      > => {

      const mutationOptions = getRemoveWorkPackageAssigneeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    